import { createContext } from 'react';
export var IconContext = /*#__PURE__*/ createContext({});
export default IconContext.Provider;
